import AssignProjectWorkerOutputPort from "@/presenters/project-worker-presenter";
import ProjectWorkerGateway from "@/gateways/project-worker-gateway";
import { StaffId } from "@/entities/ids";

export default interface ProjectWorkerInputPort {
  index(): Promise<void>;
  assign(id: StaffId): Promise<void>;
  unassign(id: StaffId): Promise<void>;
  assignAll(ids: StaffId[]): Promise<void>;
  unassignAll(ids: StaffId[]): Promise<void>;
}

export class ProjectWorkerInteractor implements ProjectWorkerInputPort {
  public constructor(
    private presenter: AssignProjectWorkerOutputPort,
    private workers: ProjectWorkerGateway
  ) {}

  public async index() {
    this.presenter.info(await this.workers.all());
  }

  public async assign(id: StaffId) {
    try {
      await this.workers.assign(id);
      this.index();
    } catch (e) {
      this.presenter.error(e);
    }
  }

  public async unassign(id: StaffId) {
    try {
      await this.workers.unassign(id);
      this.index();
    } catch (e) {
      this.presenter.error(e);
    }
  }

  public async assignAll(ids: StaffId[]) {
    try {
      await Promise.all(ids.map(id => this.workers.assign(id)));
      this.index();
    } catch (e) {
      this.presenter.error(e);
    }
  }

  public async unassignAll(ids: StaffId[]) {
    try {
      await Promise.all(ids.map(id => this.workers.unassign(id)));
      this.index();
    } catch (e) {
      this.presenter.error(e);
    }
  }
}
